module.exports = __webpack_public_path__ + "static/home-page-b8f28ee5348d09f56feb0dbf14ff0b14.png";